<template>
  <div>
    <egg-description
      title="telemedicine.telemedicineProvide"
      titleColor="#7BA7D8"
      :starIconObj="{ componentName: 'shared', imgName: 'starIconLightBlue', imgFormat: 'svg' }"
      :eggImgObj="{ componentName: 'telemedicine', imgName: 'teleconsultationProvide', imgFormat: 'svg', position: 'left' }"
      :isShowStarBackgroundLeft="false"
      :starBackgroundRightObj="{ componentName: 'shared', imgName: 'starGroupIconLightBlueRight', imgFormat: 'svg', top: '-30%' }"
      textMode="line"
      :description="telemedicineStore.teleconsultationProvideList"
      class="pb-24"
    />

    <egg-description
      title="telemedicine.teleconsultationForMe"
      titleColor="#7BA7D8"
      :starIconObj="{ componentName: 'shared', imgName: 'starIconLightBlue', imgFormat: 'svg' }"
      :eggImgObj="{ componentName: 'telemedicine', imgName: 'teleconsultationForMe', imgFormat: 'svg', position: 'right' }"
      :isShowStarBackgroundRight="false"
      :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconLightBlueLeft', imgFormat: 'svg', bottom: '60%' }"
      textMode="paragraph"
      :description="telemedicineStore.teleconsultationForMeList"
      :footer="telemedicineStore.teleconsultataionBottomList"
      class="pb-24"
    />
  </div>
</template>

<script setup lang="ts">
import { useTelemedicineStore } from "@/stores/telemedicine";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const telemedicineStore = useTelemedicineStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>